export default angular.module("mars.vet.dnareports.controllers.pbddletter",[]).controller('PBDDLetterController', 
        function($rootScope, $scope, $window, 
                EntryService, NavigationService, FileService, TranslationService, EntryIDService, UtilityService,
                reportdata) {

    'ngInject';

    var resultString = reportdata.resultString;
    var sampleDetails = reportdata.sampleDetails;

    var letter = "/staticresources/dnareports/images/" + resultString.sampleID + "/lettercontent.xml";
    $scope.letterTest = letter;
    var reportType = 'online';
    $scope.onloadFun = function() {
        reportType = 'pdf';
    }
    EntryService.getEntry('57xEDReh84GyeuiCsC4YCW').then(function(response) {
        var fields = response.fields;
        $scope.lastName = sampleDetails.ownerName.lastName;
        $scope.firstName = sampleDetails.ownerName.firstName;
        $scope.attentionMsg = "Attention! " + $scope.lastName;
        var letterContent = "";
        var letterFlag = resultString.event[0]['letterflag'];
        $scope.date = UtilityService.formatDate(resultString.event[0]['eventDate']);
        var outcomeFinal;
        var resultPbDdBreed = resultString.resultPbDdBreed;
        var breedName1 = "";
        var breedName2 = "";
        var pbDd = "";

        if (resultPbDdBreed !== undefined && resultPbDdBreed !== null && resultPbDdBreed.length > 0) {
            breedName1 = resultPbDdBreed[0]['breed_1'];
            breedName2 = resultPbDdBreed[0]['breed_2'];
            pbDd = resultPbDdBreed[0]['type'] == "Wisdom_PB" ? "PB" : resultPbDdBreed[0]['type'] == "Wisdom_DD" ? "DD" : "";
        }

        $scope.evidenceDescArray = [];
        $scope.pbddLetterDesc = fields.pbddLetterDescription[pbDd];
        $scope.pbddEvidences = pbDd == 'PB' ? fields.pbEvidenceDescription : pbDd == "DD" ? fields.ddEvidenceDescription : "";
        $scope.pbddFlag = pbDd;
        $scope.resultPbDdData = resultString.resultPbDd;

        angular.forEach($scope.pbddEvidences, function(pbddData, evidence) {
            angular.forEach($scope.resultPbDdData, function(resultSet, key) {
                if (resultSet['evidence'].trim() == 'final_outcome') {
                    outcomeFinal = resultSet['outcome'];
                }
            });
        });
        if (pbDd == 'PB') {
            //		    $scope.letterType="Notes";
            if (reportType != 'pdf') {
                $rootScope.pageTitle = TranslationService.getTranslation("Notes");
            }
            $scope.mainDescription = $scope.pbddLetterDesc['DESCRIPTION'].replaceAll("[PETNAME]", sampleDetails.petDetails.petName).replaceAll("[BREEDNAME]", breedName1);
            $scope.subject = $scope.pbddLetterDesc[outcomeFinal].replaceAll("[PETNAME]", sampleDetails.petDetails.petName).replaceAll("[BREEDNAME]", breedName1);
            $scope.commonDesc = $scope.pbddLetterDesc['COMMONDESC'].replaceAll("[PETNAME]", sampleDetails.petDetails.petName).replaceAll("[BREEDNAME]", breedName1).replaceAll("[BREEDTESTLINK]", "<a href='#/breedtests/nyiWblUhCo2G0o6qSis0s'>page of your report</a>");
            $scope.letterFooter = $scope.pbddLetterDesc['LETTERFOOTER'].replaceAll("[PETNAME]", sampleDetails.petDetails.petName).replaceAll("[BREEDNAME]", breedName1);
        } else if (pbDd == 'DD') {
            //			$scope.letterType="Notes";
            if (reportType != 'pdf') {
                $rootScope.pageTitle = TranslationService.getTranslation("Notes");
            }
            $scope.mainDescription = $scope.pbddLetterDesc['DESCRIPTION'].replaceAll("[PETNAME]", sampleDetails.petDetails.petName).replaceAll("[BREEDNAME1]", breedName1).replaceAll("[BREED NAME2]", breedName2);
            $scope.subject = $scope.pbddLetterDesc[outcomeFinal].replaceAll("[PETNAME]", sampleDetails.petDetails.petName).replaceAll("[BREED NAME1]", breedName1).replaceAll("[BREED NAME2]", breedName2);
            $scope.letterFooter = $scope.pbddLetterDesc['LETTERFOOTER'].replaceAll("[PETNAME]", sampleDetails.petDetails.petName).replaceAll("[BREED NAME1]", breedName1).replaceAll("[BREED NAME2]", breedName2);
            $scope.commonDesc = $scope.pbddLetterDesc['COMMONDESC'].replaceAll("[PETNAME]", sampleDetails.petDetails.petName).replaceAll("[BREEDNAME]", breedName1).replaceAll("[BREEDTESTLINK]", "<a href='#/breedtests/nyiWblUhCo2G0o6qSis0s'>page of your report</a>");
        }
    	var init=function(){
	    $rootScope.$broadcast('checkNotifyCount',1);
	    }
	    init();
        $window.ga('send', 'pageview', {
            'page': 'PBDDLetter'
        });
    }, function(error) {
        // promise rejected, could log the error with:
        // console.log('error', error);
    });
}).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/pbddletter.controller.js